import React from "react";

import Button from "@mui/material/Button";
import ButtonGroup, { OptionType } from "./ButtonGroup";

const ExamCadence: React.FC<{
  title: string;
  options: OptionType[];
  selectedOption?: OptionType | null;
  handleChange: (option: OptionType | null) => void;
  disabled?: boolean;
  onAddButtonClick: (event: React.MouseEvent<HTMLElement>) => void;
  onResetButtonClick: () => void;
}> = (props) => {
  return (
    <div>
      <h5 className="text-[12px] text-[#231F20]">{props.title}</h5>
      <p className="text-grayDark leading-[16px] text-[12px] mt-1">
        To edit schedule click on the input and change the metric to what you’d
        prefer, “w” is week, “m” is month.
      </p>
      <div className="flex">
        <div className="flex flex-wrap">
          <ButtonGroup
            options={props.options}
            selectedOption={props.selectedOption}
            handleChange={(option) => props.handleChange(option)}
            disabled={props.disabled}
          />
        </div>

        <div className="flex gap-1 h-[36px]">
          <Button
            className="patient-recovery__btn"
            onClick={(event) => props.onAddButtonClick(event)}
            disabled={props.disabled}
          >
            Add
          </Button>

          <Button
            className="patient-recovery__btn"
            onClick={props.onResetButtonClick}
            disabled={props.disabled}
          >
            Reset
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExamCadence;
